<template>
  <div class="panel-heading">
    <slot name="panel-btn" ></slot>
    <h3 class="panel-title">{{ title }}</h3>
    <p class="description mt0" v-if="description" v-html="description"></p>
  </div>
</template>

<script>
export default {
  name: 'panel-heading',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Panel/PanelHeading.vue